/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { CURRENT_TCAS_YEAR } from 'constants/school-year';
import moment from 'moment';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';

// Hooks

// Helpers
import { formatThaiDeadline, formatThaiDate } from 'helpers';

// Components
import LoadError from 'components/LoadError';

// Data
import enabled from 'data/enabled'

const formatHistoryTime = (timestamp) =>
  `${moment(timestamp).format('D MMM')} ${(moment(timestamp).year() + 543) % 100}, ${moment(timestamp).format('HH:mm:ss')} น.`;

const RoundContent = ({ alreadyApplied, flow, roundType, loading, loadFailed, offerCount, offers, replies }) => {
  const [infoCollapsed, setInfoCollapsed] = useState(true);

  const timelineMap = {
    [`1_${CURRENT_TCAS_YEAR}`]: {
      apply: <small>{'มหาวิทยาลัยกำหนด'}</small>,
      announce: <small>{formatThaiDate(enabled.round1.reply_start)}</small>,
      reply: <small>{`10-11 มีนาคม ${CURRENT_TCAS_YEAR}`}</small>,
      cancel: <small>{`12 มีนาคม ${CURRENT_TCAS_YEAR} หรือ 5 พฤษภาคม ${CURRENT_TCAS_YEAR}`}</small>
    },
    [`2_${CURRENT_TCAS_YEAR}`]: {
      apply: <small>{'มหาวิทยาลัยกำหนด'}</small>,
      announce: <small>{formatThaiDate(enabled.round2.reply_start)}</small>,
      reply: <small>{`3-4 พฤษภาคม ${CURRENT_TCAS_YEAR}`}</small>,
      cancel: <small>{`5 พฤษภาคม ${CURRENT_TCAS_YEAR}`}</small>
    },
    [`3_${CURRENT_TCAS_YEAR}`]: {
      apply: <small>{'ที่ระบบ mytcas.com'}<br />{`7-11 พฤษภาคม ${CURRENT_TCAS_YEAR} (เพิ่มเติม 12-13 พฤษภาคม)`}</small>, // ตารางทางการ TCAS70
      announce: <small>{`1) ${formatThaiDate(enabled.round3.reply_start)}`}<br />{`2) ${formatThaiDate(enabled.round3.reprocess_announce_start)}`}</small>,
      reply: <small>{`22-23 พฤษภาคม ${CURRENT_TCAS_YEAR}`}</small>,
      cancel: <small>{`28 พฤษภาคม ${CURRENT_TCAS_YEAR}`}</small>
    },
    [`41_${CURRENT_TCAS_YEAR}`]: {
      apply: <small>{'ที่ระบบของมหาวิทยาลัย'}<br />{`29 พฤษภาคม - 15 มิถุนายน ${CURRENT_TCAS_YEAR}`}</small>,
      announce: <small>{formatThaiDate(enabled.round41.reply_start)}</small>,
      reply: <small>{`7-8 มิถุนายน ${CURRENT_TCAS_YEAR}`}</small>,
      cancel: <small>{'ไม่อนุญาตให้สละสิทธิ์ ถ้าไม่ต้องการ ไม่ต้องกดยืนยันสิทธิ์'}</small>
    },
    [`42_${CURRENT_TCAS_YEAR}`]: {
      apply: <small>{'ที่ระบบของมหาวิทยาลัย'}<br />{`29 พฤษภาคม - 15 มิถุนายน ${CURRENT_TCAS_YEAR}`}</small>,
      announce: <small>{formatThaiDate(enabled.round42.reply_start)}</small>,
      reply: <small>{`18-19 มิถุนายน ${CURRENT_TCAS_YEAR}`}</small>,
      cancel: <small>{'ไม่อนุญาตให้สละสิทธิ์ ถ้าไม่ต้องการ ไม่ต้องกดยืนยันสิทธิ์'}</small>
    }
  }

  if (flow === 'not-open') {
    const { apply, announce, reply, cancel } = timelineMap[roundType];
    return (
      <div className={cn('content', { '-announce': roundType.startsWith('3_') })}>
        <ul className="r-timeline">
          <li>
            <i><svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.25 0C1.0095 0 0 1.0095 0 2.25V17.75C0 18.9905 1.0095 20 2.25 20H7.02148C7.03948 19.8755 7.06926 19.7523 7.11426 19.6328L7.11523 19.6338C7.14173 19.5218 7.17546 19.4047 7.20996 19.2832L7.43457 18.5H2.25C1.8365 18.5 1.5 18.1635 1.5 17.75V2.25C1.5 1.8365 1.8365 1.5 2.25 1.5H8V5.75C8 6.9905 9.0095 8 10.25 8H14.5V9.91602C14.9405 9.50402 15.4535 9.22471 16 9.09571V7.25C16 7.04275 15.916 6.85542 15.7803 6.71973L9.28027 0.219727C9.14458 0.0840391 8.95725 0 8.75 0H2.25ZM9.5 2.56055L13.4395 6.5H10.25C9.8365 6.5 9.5 6.1635 9.5 5.75V2.56055ZM16.749 10C16.612 10.0005 16.4735 10.0126 16.334 10.0381C15.892 10.1176 15.4698 10.3481 15.1133 10.7051L9.21387 16.6045C9.03537 16.783 8.90398 17.0056 8.83398 17.2471L8.04883 19.9873C8.01283 20.0823 7.9965 20.1827 8 20.2832C8.0065 20.4647 8.0778 20.6442 8.21679 20.7832C8.3553 20.9217 8.53384 20.993 8.71484 21C8.81534 21.0035 8.91719 20.9877 9.01269 20.9512L11.7529 20.166C11.9944 20.096 12.2155 19.9651 12.3945 19.7861L18.2949 13.8867C18.6519 13.5302 18.8824 13.108 18.9619 12.666C18.9869 12.5265 18.9985 12.388 18.999 12.251C19.0005 11.654 18.7703 11.0897 18.3398 10.6602C17.9103 10.2302 17.346 9.999 16.749 10Z" fill="#1A477F"></path>
            </svg></i><span><b>รับสมัคร</b>
              <p>{apply}</p>
            </span>
          </li>
          <li>
            <i><svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.6084 0.0507829C11.5425 0.05068 11.4762 0.0555121 11.4102 0.0644547C11.1458 0.100225 10.8851 0.20928 10.6699 0.400392C10.6699 0.400718 10.6699 0.401043 10.6699 0.401369L6.05859 4.5H2.75C1.51625 4.5 0.5 5.51625 0.5 6.75V11.25C0.5 12.4838 1.51625 13.5 2.75 13.5H6.05859L10.6699 17.5986C11.1003 17.9813 11.7107 18.0376 12.1728 17.8301C12.635 17.6226 13 17.1287 13 16.5527V1.44727C13 0.871536 12.636 0.377489 12.1738 0.169923C12.0005 0.0920862 11.8062 0.0510916 11.6084 0.0507829ZM11.5 1.66992V16.3301L6.8418 12.1895C6.70456 12.0675 6.52736 12.0001 6.34375 12H2.75C2.32675 12 2 11.6733 2 11.25V6.75C2 6.32675 2.32675 6 2.75 6H6.34375C6.52736 5.99994 6.70456 5.93253 6.8418 5.81055L11.5 1.66992ZM17.3779 2.99024C17.2478 2.9897 17.1198 3.02302 17.0065 3.08693C16.8931 3.15083 16.7983 3.24312 16.7315 3.35473C16.6646 3.46634 16.6279 3.59342 16.625 3.72351C16.622 3.85359 16.653 3.98219 16.7148 4.09668C18.4445 7.40905 18.4445 10.591 16.7148 13.9033C16.6674 13.9908 16.6379 14.0869 16.6279 14.1859C16.618 14.2849 16.6278 14.385 16.6569 14.4801C16.686 14.5753 16.7338 14.6638 16.7974 14.7403C16.861 14.8168 16.9393 14.8799 17.0275 14.926C17.1158 14.972 17.2123 14.9999 17.3115 15.0083C17.4107 15.0166 17.5105 15.0051 17.6052 14.9745C17.6999 14.9438 17.7875 14.8946 17.863 14.8298C17.9385 14.7649 18.0004 14.6857 18.0449 14.5967C19.9653 10.9191 19.9653 7.08095 18.0449 3.40332C17.9827 3.27961 17.8875 3.17553 17.7697 3.10262C17.652 3.02971 17.5164 2.99081 17.3779 2.99024ZM15.0859 5.49805C14.9622 5.50333 14.8417 5.53918 14.7351 5.6024C14.6286 5.66561 14.5394 5.75423 14.4755 5.86033C14.4115 5.96642 14.3749 6.0867 14.3688 6.21042C14.3626 6.33415 14.3873 6.45745 14.4404 6.56934C15.1987 8.22856 15.1976 9.77991 14.4365 11.4395C14.3948 11.5291 14.3712 11.626 14.367 11.7248C14.3629 11.8236 14.3783 11.9222 14.4124 12.0149C14.4465 12.1077 14.4986 12.1929 14.5657 12.2654C14.6328 12.338 14.7136 12.3966 14.8034 12.4379C14.8933 12.4791 14.9904 12.5022 15.0892 12.5058C15.1879 12.5094 15.2865 12.4934 15.3791 12.4588C15.4716 12.4242 15.5565 12.3716 15.6287 12.3041C15.7009 12.2366 15.759 12.1555 15.7998 12.0654C16.7187 10.062 16.7204 7.94909 15.8047 5.94531C15.7438 5.80706 15.6427 5.6904 15.5144 5.61059C15.3862 5.53079 15.2368 5.49156 15.0859 5.49805Z" fill="#1A477F"></path>
            </svg></i><span><b>ประกาศผลในระบบ</b>
              <p>{announce}</p>
            </span>
          </li>
          <li>
            <i><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 0C4.48603 0 0 4.48604 0 10C0 15.514 4.48603 20 10 20C15.514 20 20 15.514 20 10C20 4.48604 15.514 0 10 0ZM10 1.5C14.7033 1.5 18.5 5.2967 18.5 10C18.5 14.7033 14.7033 18.5 10 18.5C5.29669 18.5 1.5 14.7033 1.5 10C1.5 5.2967 5.29669 1.5 10 1.5ZM13.7354 6.99317C13.5406 6.99884 13.3557 7.0801 13.2197 7.21973L8.75 11.6895L6.78028 9.71973C6.71117 9.64775 6.62839 9.59028 6.53679 9.5507C6.4452 9.51111 6.34662 9.4902 6.24684 9.48918C6.14706 9.48817 6.04809 9.50707 5.9557 9.54479C5.86332 9.58251 5.77939 9.63828 5.70884 9.70884C5.63828 9.77939 5.58251 9.86332 5.54479 9.9557C5.50707 10.0481 5.48817 10.1471 5.48918 10.2468C5.4902 10.3466 5.51111 10.4452 5.5507 10.5368C5.59028 10.6284 5.64775 10.7112 5.71973 10.7803L8.21973 13.2803C8.36039 13.4209 8.55112 13.4999 8.75 13.4999C8.94888 13.4999 9.13962 13.4209 9.28028 13.2803L14.2803 8.28028C14.3885 8.1749 14.4623 8.03931 14.4922 7.89126C14.5221 7.7432 14.5066 7.58958 14.4477 7.4505C14.3888 7.31142 14.2893 7.19335 14.1622 7.11175C14.0351 7.03015 13.8863 6.98882 13.7354 6.99317V6.99317Z" fill="#1A477F"></path>
            </svg></i><span><b>ยืนยันสิทธิ์ในระบบ</b>
              <p>{reply}</p>
            </span>
          </li>
          <li>
            <i><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 0C4.48603 0 0 4.48604 0 10C0 15.514 4.48603 20 10 20C15.514 20 20 15.514 20 10C20 4.48604 15.514 0 10 0ZM10 1.5C14.7033 1.5 18.5 5.2967 18.5 10C18.5 14.7033 14.7033 18.5 10 18.5C5.29669 18.5 1.5 14.7033 1.5 10C1.5 5.2967 5.29669 1.5 10 1.5ZM13.2432 5.98926C13.0451 5.99394 12.8569 6.07679 12.7197 6.21973L10 8.93946L7.28028 6.21973C7.21037 6.14774 7.12672 6.0905 7.0343 6.05142C6.94187 6.01233 6.84254 5.99219 6.74219 5.99219C6.59293 5.99223 6.44707 6.03679 6.32328 6.12019C6.19949 6.20359 6.1034 6.32202 6.0473 6.46033C5.9912 6.59865 5.97763 6.75056 6.00835 6.89663C6.03907 7.04269 6.11267 7.17627 6.21973 7.28028L8.93946 10L6.21973 12.7197C6.14775 12.7888 6.09028 12.8716 6.0507 12.9632C6.01111 13.0548 5.9902 13.1534 5.98918 13.2532C5.98817 13.3529 6.00707 13.4519 6.04479 13.5443C6.08251 13.6367 6.13828 13.7206 6.20884 13.7912C6.27939 13.8617 6.36332 13.9175 6.4557 13.9552C6.54809 13.9929 6.64706 14.0118 6.74684 14.0108C6.84662 14.0098 6.9452 13.9889 7.03679 13.9493C7.12839 13.9097 7.21117 13.8523 7.28028 13.7803L10 11.0605L12.7197 13.7803C12.7888 13.8523 12.8716 13.9097 12.9632 13.9493C13.0548 13.9889 13.1534 14.0098 13.2532 14.0108C13.3529 14.0118 13.4519 13.9929 13.5443 13.9552C13.6367 13.9175 13.7206 13.8617 13.7912 13.7912C13.8617 13.7206 13.9175 13.6367 13.9552 13.5443C13.9929 13.4519 14.0118 13.3529 14.0108 13.2532C14.0098 13.1534 13.9889 13.0548 13.9493 12.9632C13.9097 12.8716 13.8523 12.7888 13.7803 12.7197L11.0605 10L13.7803 7.28028C13.8893 7.1756 13.9642 7.0404 13.9951 6.89242C14.026 6.74444 14.0115 6.59058 13.9534 6.45101C13.8953 6.31143 13.7965 6.19266 13.6697 6.11026C13.543 6.02787 13.3943 5.98569 13.2432 5.98926Z" fill="#1A477F"></path>
            </svg></i><span><b>สละสิทธิ์ในระบบ</b>
              <p>{cancel}</p>
            </span>
          </li>
        </ul>
      </div>
    )
  }

  // Already applied
  if (alreadyApplied) {
    return (
      <div className="content">
        <div>
          <h3>{'ท่านไม่มีสิทธิ์สมัครในรอบนี้'}</h3>
          <p>{'ผู้สมัครมีการยืนยันสิทธิ์เข้าศึกษาในมหาวิทยาลัยในรอบอื่นแล้ว'}</p>
        </div>
      </div>
    )
  }

  // Loading
  if (loading) {
    return (
      <div className="content">
        <div>
          <h3>{'กำลังโหลดข้อมูล...'}</h3>
        </div>
      </div>
    );
  }

  // โหลด offers ไม่สำเร็จ — ห้ามตกไปเคส "ไม่พบข้อมูลการสมัคร" เพราะจะหลอก user ว่าไม่ติด
  if (loadFailed) {
    return <LoadError />;
  }

  // Did not apply
  if (!offerCount) {
    return (
      <div className="content">
        <div>
          <h3>{'ไม่พบข้อมูลการสมัครในรอบนี้'}</h3>
          <p>{'หากมีข้อสงสัยเกี่ยวกับผลการคัดเลือกให้ติดต่อกับสถาบันที่ท่านสมัคร'}</p>
        </div>
      </div>
    );
  }

  // Apply but did not pass
  if (!(offers || []).length) {
    return (
      <div className="content">
        <div>
          <h3>{'ท่านไม่ผ่านการคัดเลือกในรอบนี้'}</h3>
          <p>{'หากมีข้อสงสัยเกี่ยวกับผลการคัดเลือกให้ติดต่อกับสถาบันที่ท่านสมัคร'}</p>
        </div>
      </div>
    );
  }

  const lastReply = _.last(replies);
  if (lastReply) {
    if (!lastReply.enrollment_offer) {
      // Latest status is `rejected`
      const createdAt = _.get(lastReply, 'timestamp')
        ? `${moment(lastReply.timestamp).format('D MMM')} ${(moment(lastReply.timestamp).year() + 543) % 100} ${moment(lastReply.timestamp).format('HH:mm:ss')} น.`
        : '';
      return (
        <div className="content">
          <h3>
            <b className="color-red">{'ท่านไม่ใช้สิทธิ์ในรอบนี้'}</b>
          </h3>
          <small>{createdAt}</small>
          <div className={cn('r-more', { active: !infoCollapsed })}>
            <h4 onClick={() => setInfoCollapsed((_collapsed) => !_collapsed)}>
              {'ข้อมูลเพิ่มเติม'} <i className="i-more"></i>
            </h4>
            <div className="more">
              <LastReplyBox roundType={roundType} replies={replies} flow={flow}>
                <h2 style={{ margin: 0 }}>
                  {'ท่านยืนยัน'} <span className="color-red">{'ไม่ใช้สิทธิ์ในรอบนี้'}</span>
                </h2>
              </LastReplyBox>
              {replies.length < 3 && flow === 'default' && (
                <>
                  <h4>{'หากผู้สมัครต้องการเปลี่ยนเป็นยืนยันสิทธิ์ ให้เลือก​ 1 สาขาวิชาในรายการต่อไปนี้'}</h4>
                  <SectionChoose roundType={roundType} offers={offers} replies={replies} />
                </>
              )}
              <SectionHistory roundType={roundType} offers={offers} replies={replies} />
            </div>
          </div>
        </div>
      );
    } else {
      // Latest status is `accepted`
      const program = _.get(lastReply, 'enrollment_offer.program') || {};
      const isCanceled = _.get(lastReply, 'is_canceled');
      const createdAt = _.get(lastReply, 'timestamp')
        ? `${moment(lastReply.timestamp).format('D MMM')} ${(moment(lastReply.timestamp).year() + 543) % 100} ${moment(lastReply.timestamp).format('HH:mm:ss')} น.`
        : '';
      const majorName = _.get(program, `major_name_th`);
      const projectName = _.get(lastReply, `program_project.project_name_th`);

      return (
        <div className="content">
          <h3>{(isCanceled ? 'ท่านสละสิทธิ์ในรอบนี้' : 'ยืนยันสิทธิ์เรียบร้อยแล้ว')}</h3>
          <small>{createdAt}</small>

          <ul className={cn('r-choose', { '-done': !isCanceled, '-cancel': isCanceled })}>
            <li>
              <label>
                <div className="num">
                  <i className="i-check"></i>
                </div>
                <span
                  className="u-logo"
                  style={{ backgroundImage: `url('/assets/img/logo/${_.get(program, 'university_id')}.png')` }}
                />
                <strong>{_.get(program, `university_name_th`)}</strong>
                {_.get(program, `campus_name_th`)}
                <br />
                {_.get(program, `faculty_name_th`)}
                <br />
                {_.get(program, `field_name_th`)}
                <br />
                {majorName && majorName !== '0' ? (
                  <>
                    {'วิชาเอก'}
                    {majorName}
                    <br />
                  </>
                ) : null}
                {_.get(program, `program_name_th`)}
                <br />
                {`(${_.get(program, `program_type_name_th`)})`}
                {projectName && projectName !== '0' ? (
                  <>
                    <br />
                    {'โครงการ '}
                    {projectName}
                  </>
                ) : null}
              </label>
            </li>
          </ul>

          <div className={cn('r-more', { active: !infoCollapsed })}>
            <h4 onClick={() => setInfoCollapsed((_collapsed) => !_collapsed)}>
              {'ข้อมูลเพิ่มเติม'} <i className="i-more"></i>
            </h4>
            <div className="more">
              {['cancel', 'cancel-expired'].includes(flow) ? (
                <LastReplyBox isCanceled={isCanceled} roundType={roundType} flow={flow} replies={replies}>
                  {!isCanceled ? (
                    <h2 style={{ margin: 0 }}>
                      {'ท่าน'} <span className="color-green">{'ยืนยันสิทธิ์'}</span> {'เรียบร้อยแล้ว'}
                    </h2>
                  ) : (
                    <h2 style={{ margin: 0 }}>
                      {'ท่าน'} <span className="color-red">{'สละสิทธิ์'}</span> {'ในรอบนี้'}
                    </h2>
                  )}
                </LastReplyBox>
              ) : (
                <LastReplyBox roundType={roundType} flow={flow} replies={replies}>
                  <h2 style={{ margin: 0 }}>
                    {'ท่าน'} <span className="color-green">{'ยืนยันสิทธิ์'}</span> {'เรียบร้อยแล้ว'}
                  </h2>
                </LastReplyBox>
              )}
              {flow === 'cancel' && !isCanceled ? (
                <div className="r-deny">
                  <h4>
                    {'หากผู้สมัครต้องการสละสิทธิ์ในรอบนี้ ให้กด'} <b>{'สละสิทธิ์'}</b> {'ภายใน'}
                  </h4>

                  <Counter roundType={roundType} flow={flow} />
                  <Link className="btn-icon btn-deny" to={`/profile/offer-cancel/${roundType}`}>
                    <span className="icon">
                      {' '}
                      <i className="i-heart"></i> -1{' '}
                    </span>
                    <b className="text">{'สละสิทธิ์'}</b>
                  </Link>
                </div>
              ) : (
                replies.length < 3 &&
                flow === 'default' && (
                  <>
                    {offers.length > 1 && (
                      <>
                        <h4>{'หากผู้สมัครต้องการเปลี่ยนการยืนยันสิทธิ์ ให้เลือก 1 สาขาวิชาในรายการต่อไปนี้'}</h4>
                        <SectionChoose roundType={roundType} offers={offers} replies={replies} />
                      </>
                    )}
                    <div className="r-deny">
                      <h4>
                        {'หากผู้สมัคร'} <b>{'ไม่ประสงค์จะเข้าศึกษา'}</b><br />{'ในทุกสาขาวิชาที่ผ่านการคัดเลือก'} {'ให้กด'}{' '}
                        <b>{'ไม่ใช้สิทธิ์'}</b> {(replies.length && offers.length === 1) && 'ภายใน'}
                      </h4>
                      {offers.length === 1 && <Counter roundType={roundType} flow={flow} />}
                      <Link className="btn-icon btn-deny" to={`/profile/offer-reject/${roundType}`}>
                        <span className="icon">
                          {' '}
                          <i className="i-heart"></i> -1{' '}
                        </span>
                        <b className="text">{'ไม่ใช้สิทธิ์'}</b>
                      </Link>
                    </div>
                  </>
                )
              )}
              <SectionHistory roundType={roundType} offers={offers} replies={replies} />
            </div>
          </div>
        </div>
      );
    }
  }

  if (flow !== 'default') {
    return (
      <div className="content">
        {!loading ? (
          <h3>
            <b className="color-red">{'ท่านไม่ใช้สิทธิ์ในรอบนี้'}</b>
          </h3>
        ) : null}
      </div>
    );
  }

  return (
    <div className="content">
      <h3>
        {'ท่านผ่านการคัดเลือก'} {(offers || []).length} {'สาขาวิชา'}
      </h3>
      <h4>{'กรุณาเลือกสาขาวิชาที่ท่านต้องการยืนยันสิทธิ์ภายใน'}</h4>
      <Counter roundType={roundType} flow={flow} />

      <div className="i-hearts">
        <i className={cn('i-heart', { '-used': replies.length > 2 })} />
        <i className={cn('i-heart', { '-used': replies.length > 1 })} />
        <i className={cn('i-heart', { '-used': replies.length > 0 })} />
        <small>{'สามารถตัดสินใจได้ 3 ครั้ง'}</small>
      </div>
      <SectionChoose roundType={roundType} offers={offers} replies={replies} />
      <div className="r-deny">
        <h4>
          {'หากผู้สมัคร'} <b>{'ไม่ประสงค์จะเข้าศึกษา'}</b><br />{'ในทุกสาขาวิชาที่ผ่านการคัดเลือก'} {'ให้กด'}{' '}
          <b>{'ไม่ใช้สิทธิ์'}</b>
        </h4>
        <Link className="btn-icon btn-deny" to={`/profile/offer-reject/${roundType}`}>
          <span className="icon">
            {' '}
            <i className="i-heart"></i> -1{' '}
          </span>
          <b className="text">{'ไม่ใช้สิทธิ์'}</b>
        </Link>
      </div>
    </div>
  );
};

export default RoundContent;

const Counter = ({ roundType, flow }) => {
  const endTime = _.get(enabled, `round${roundType.split('_')[0]}.${flow === 'cancel' ? 'cancel_end' : 'reply_end'}`);
  const [timer, setTimer] = useState(endTime ? moment(endTime).diff(moment(), 'seconds') : null);

  useEffect(() => {
    // interval เดียวตลอดอายุ component (เดิม deps [timer] ทำให้รื้อ-สร้างใหม่ทุกวินาที)
    const _interval = setInterval(() => setTimer((_time) => (_time > 0 ? _time - 1 : _time)), 1000);
    return () => clearInterval(_interval);
  }, []);
  const [hh, mm, ss] = [parseInt(timer / 3600, 10), parseInt(timer / 60, 10) % 60, timer % 60];

  return (
    <ul className="r-counter">
      <li>
        <b>{hh}</b>
        {'ชั่วโมง'}
      </li>
      <li>
        <b>{mm}</b>
        {'นาที'}
      </li>
      <li>
        <b>{ss}</b>
        {'วินาที'}
      </li>
    </ul>
  );
};

const OfferItem = ({ offer, checked, index, onSelect }) => {

  const program = offer.program || {};
  const universityName = program.university_name_th;
  const campusName = program.campus_name_th;
  const facultyName = program.faculty_name_th;
  const fieldName = `สาขา${program.field_name_th}`;
  const majorName = program.major_name_th;
  const programName = program.program_name_th;
  const programTypeName = `(${program.program_type_name_th})`;
  const projectName =
    _.get(offer, 'program_project.project_name_th');

  return (
    <li key={offer._id} className={cn({ active: checked })}>
      <label>
        <div className="num">
          <b>{index + 1}</b>
        </div>
        <input type="radio" name="r-1" checked={checked} onClick={onSelect} />
        <span className="u-logo" style={{ backgroundImage: `url('/assets/img/logo/${program.university_id}.png')` }} />
        <strong>{universityName}</strong>
        {campusName}
        <br />
        {facultyName}
        <br />
        {fieldName}
        <br />
        {majorName && majorName !== '0' ? (
          <>
            {'วิชาเอก'}
            {majorName}
            <br />
          </>
        ) : null}
        {programName}
        <br />
        {programTypeName}
        {projectName && projectName !== '0' ? (
          <>
            <br />
            {'โครงการ '}
            {projectName}
          </>
        ) : null}
      </label>
    </li>
  );
};

const ReplyLog = ({ reply, roundType, replyIndex }) => {
  if (!reply.enrollment_offer) {
    return (
      <li>
        <h4 className="color-red">
          {'ไม่ใช้สิทธิ์'} ({'ตัดสินใจครั้งที่ '}{replyIndex + 1}/3)
        </h4>
        <div className="u-log">
          <h4>
            {'ไม่ใช้สิทธิ์รอบที่'} {roundType.slice(0, 1)}
          </h4>
        </div>
        <time>
          {moment(reply.timestamp).format('D MMM')} {(moment(reply.timestamp).year() + 543) % 100}{' '}
          {moment(reply.timestamp).format('HH:mm:ss')} น.
        </time>
      </li>
    );
  }

  const majorName = _.get(reply, `enrollment_offer.program.major_name_th`);
  const projectName = _.get(reply, `program_project.project_name_th`);
  return (
    <li>
      {reply.is_canceled ? (
        <h4 className="color-red">{'สละสิทธิ์'}</h4>
      ) : (
        <h4 className="color-green">
          {'ยืนยันสิทธิ์'} ({'ตัดสินใจครั้งที่ '}{replyIndex + 1}/3)
        </h4>
      )}

      <div className="u-log">
        <h4>{_.get(reply, `enrollment_offer.program.university_name_th`)}</h4>
        <b>{_.get(reply, `enrollment_offer.program.campus_name_th`)}</b>
        <br />
        {_.get(reply, `enrollment_offer.program.faculty_name_th`)}{' '}
        {_.get(reply, `enrollment_offer.program.field_name_th`)}
        <br />
        {majorName && majorName !== '0' ? (
          <>
            {'วิชาเอก'}
            {majorName}
            <br />
          </>
        ) : null}
        {_.get(reply, `enrollment_offer.program.program_name_th`)}{' '}
        {`(${_.get(reply, `enrollment_offer.program.program_type_name_th`)})`}
        {projectName && projectName !== '0' ? (
          <>
            <br />
            {'โครงการ '}
            {projectName}
          </>
        ) : null}
      </div>
      <time>
        {moment(reply.timestamp).format('D MMM')} {(moment(reply.timestamp).year() + 543) % 100}{' '}
        {moment(reply.timestamp).format('HH:mm:ss')} น.
      </time>
    </li>
  );
};

const OfferLog = ({ offer }) => {
  const majorName = _.get(offer, `program.major_name_th`);
  const projectName = _.get(offer, `program_project.project_name_th`);
  return (
    <div className="u-log">
      <h4>{_.get(offer, `program.university_name_th`)}</h4>
      <b>{_.get(offer, `program.campus_name_th`)}</b>
      <br />
      {_.get(offer, `program.faculty_name_th`)} {_.get(offer, `program.field_name_th`)}
      <br />
      {majorName && majorName !== '0' ? (
        <>
          {'วิชาเอก'}
          {majorName}
          <br />
        </>
      ) : null}
      {_.get(offer, `program.program_name_th`)}{' '}
      {`(${_.get(offer, `program.program_type_name_th`)})`}
      {projectName && projectName !== '0' ? (
        <>
          <br />
          {'โครงการ '}
          {projectName}
        </>
      ) : null}
    </div>
  );
};

const SectionChoose = ({ roundType, flow = 'default', offers = [], replies = [] }) => {
  const navigate = useNavigate();
  const [selectedOfferId, setSelectedOfferId] = useState(_.get(_.last(replies), 'enrollment_offer._id'));
  useEffect(() => {
    setSelectedOfferId(_.get(_.last(replies), 'enrollment_offer._id'));
  }, [replies]);

  const lastOfferId = _.get(_.last(replies), 'enrollment_offer._id');
  const disabled = !selectedOfferId || selectedOfferId === lastOfferId;
  return (
    <ul className="r-choose">
      {(offers || []).map((offer, index) => (
        <OfferItem
          key={offer._id}
          index={index}
          offer={offer}
          checked={offer._id === selectedOfferId}
          onSelect={() => setSelectedOfferId(offer._id)}
        />
      ))}
      {replies.length ? (
        <>
          {(offers.length > 1 || !lastOfferId || (offers.length === 1 && selectedOfferId !== lastOfferId)) && (
            <li className="action">
              <h4>
                {'ท่านสามารถ'} <b className="color-green">{'ยืนยันสิทธิ์'}</b> {'ได้ 1 สาขาวิชา ภายใน'}
              </h4>
              <Counter roundType={roundType} flow={flow} />
              <a
                className={cn('btn-icon', { disabled, 'cursor-pointer': !disabled })}
                onClick={disabled ? () => { } : () => navigate(`/profile/offer-accept/${roundType}/${selectedOfferId}`)}
              >
                <span className="icon">
                  {' '}
                  <i className="i-heart"></i>
                  <small>-1</small>
                </span>
                <b className="text">{'ยืนยันสิทธิ์'}</b>
              </a>
            </li>
          )}
        </>
      ) : (
        <li className="action">
          <h4>
            {'ท่านสามารถ'} <b className="color-green">{'ยืนยันสิทธิ์'}</b> {'ได้'} 1{' '}
            {'สาขาวิชา และเปลี่ยนแปลงได้อีกเพียง'} {2 - (replies || []).length} {'ครั้ง'}
          </h4>
          <a
            className={cn('btn-icon', { disabled: !selectedOfferId, 'cursor-pointer': selectedOfferId })}
            onClick={
              !selectedOfferId ? () => { } : () => navigate(`/profile/offer-accept/${roundType}/${selectedOfferId}`)
            }
          >
            <span className="icon">
              {' '}
              <i className="i-heart"></i>
              <small>-1</small>
            </span>
            <b className="text">{'ยืนยันสิทธิ์'}</b>
          </a>
        </li>
      )}
    </ul>
  );
};

const SectionHistory = ({ roundType, offers, replies }) => {
  const [historyCollapsed, setHistoryCollapsed] = useState(true);
  const timeMap = {
    [`1_${CURRENT_TCAS_YEAR}`]: formatHistoryTime(enabled.round1.reply_start),
    [`2_${CURRENT_TCAS_YEAR}`]: formatHistoryTime(enabled.round2.reply_start),
    [`41_${CURRENT_TCAS_YEAR}`]: formatHistoryTime(enabled.round41.reply_start),
    [`42_${CURRENT_TCAS_YEAR}`]: formatHistoryTime(enabled.round42.reply_start),
  }
  return (
    <div className={cn('r-more', { active: !historyCollapsed })}>
      <h4 onClick={() => setHistoryCollapsed((_collapsed) => !_collapsed)}>
        {'ประวัติการดำเนินการ'} <i className="i-more"></i>
      </h4>
      <div className="more">
        <ul className="r-history">
          {(replies || [])
            .slice()
            .reverse()
            .map((reply, index) => (
              <ReplyLog
                key={reply._id}
                roundType={roundType}
                replyIndex={replies.length - 1 - index}
                reply={reply}
              />
            ))}
          <li>
            <h4 className="color-green">{'ผ่านการคัดเลือก'}</h4>
            {(offers || [])
              .slice()
              .reverse()
              .map((offer) => (
                <OfferLog key={offer._id} offer={offer} />
              ))}
            <time> {timeMap[roundType]} </time>
          </li>
        </ul>
      </div>
    </div>
  );
};

// กล่อง "หากต้องการสละสิทธิ์…เพื่อสมัครรอบถัดไป" ของรอบ 1 และ 2 — ขับด้วย enabled.json ล้วน
// วันที่มาจาก enabled.round{1,2}.cancel_end, ข้อความรอบเป้าหมายมาจาก cancel_target
// (เดิมเป็น 2 บล็อก + บรรทัด comment ที่ต้องสลับมือทุกครั้งที่ cancel window เลื่อน — ตอนนี้แก้ที่ config จุดเดียว)
const CancelNotice = ({ roundType }) => {
  const cfg = enabled[`round${roundType.split('_')[0]}`];
  if (!cfg || !cfg.cancel_target) return null; // มีเฉพาะรอบ 1 และ 2
  return (
    <>
      <p>{'หากต้องการสละสิทธิ์ ระบบกำหนดให้ทำได้เพียง 1 ครั้ง ภายในวันที่'} <b>{formatThaiDeadline(cfg.cancel_end)}</b> {(cfg.cancel_target)}</p>
      <p><strong className="color-red">{'หากสละสิทธิ์ครั้งที่ 2 จะไม่สามารถเข้าสู่'}
        {'กระบวนการสมัครและคัดเลือกในรอบต่อไปได้'}</strong></p>
      <p>
        {'ท่านไม่สามารถขอยกเลิกการสละสิทธิ์'}
        {'ภายหลังจากที่ได้สละสิทธิ์เรียบร้อยแล้ว'}
      </p>
      <div className="i-hearts">
        <i className="i-heart" />
        <small>{'สามารถตัดสินใจได้ 1 ครั้งเท่านั้น เพื่อสมัครในรอบต่อไป'}</small>
      </div>
    </>
  );
};

const LastReplyBox = ({ roundType, replies = [], flow, isCanceled, children }) => {
  const quotaUsed = replies.length;
  const chosen = flow === 'expired' || (flow === 'cancel' && !isCanceled && _.get(_.last(replies), 'enrollment_offer'));
  const infoState = (!chosen || flow === 'expired');

  return (
    <div className={cn('t-box', { '-info': infoState, '-choose': !infoState })}>
      {children}
      {chosen ? (
        <CancelNotice roundType={roundType} />
      ) : (
        flow === 'default' && (
          <>
            {quotaUsed === 3 ? 'ไม่สามารถเปลี่ยนแปลงได้อีก' : `${'ตัดสินใจไปแล้ว'} ${quotaUsed} ${'ครั้ง'}`}
            {quotaUsed > 0 && (
              <>
                <div className="i-hearts">
                  <i className={cn('i-heart', { '-used': quotaUsed > 2 })} />
                  <i className={cn('i-heart', { '-used': quotaUsed > 1 })} />
                  <i className={cn('i-heart', { '-used': quotaUsed > 0 })} />
                  <small>
                    {quotaUsed === 3
                      ? 'ตัดสินใจครบ 3 ครั้งแล้ว'
                      : `${'สามารถตัดสินใจได้อีก'} ${3 - quotaUsed} ${'ครั้ง'}`}
                  </small>
                </div>
              </>
            )}
          </>
        )
      )}
    </div>
  );
};
